import comp from "./ModalitiesViewer";
export default comp;
